var PARTNERS_LOCALES = {
    asurion: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    att: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    'bell-mobility': {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    businessolver: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    'claro-brazil': {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    comcast: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    cox: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    cricket: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    dish: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    freedommobile: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    koodo: {
        defaultLocale: 'en-CA',
        supportedLocales: ['en-CA', 'fr-CA']
    },
    liberty: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US', 'es-US', 'es-PR']
    },
    mediacom: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    metro: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    mobileprotect: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    ntelos: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    samsung: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    sprint: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    telcel: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    telus: {
        defaultLocale: 'en-CA',
        supportedLocales: ['en-CA', 'fr-CA']
    },
    tesco: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    threeuk: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    'us-cellular': {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    homeplus: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    'virgin-eu': {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    virgin: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    },
    verizon: {
        defaultLocale: 'en-US',
        supportedLocales: ['en-US']
    }
};
export { PARTNERS_LOCALES };
